export const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API || '';
export const REACT_APP_API_VERSION = process.env.REACT_APP_API_VERSION || '';

export default {
    REACT_APP_BASE_API,
    REACT_APP_API_VERSION
};